import { NgControl } from '@angular/forms';
import { Directive, Input, inject } from '@angular/core';

@Directive({
  selector: '[disableControl]',
  standalone: false,
})
export class DisableControlDirective {
  private ngControl = inject(NgControl, { optional: true, skipSelf: true });

  @Input() set disableControl(condition: boolean) {
    const action = condition ? 'disable' : 'enable';
    this.ngControl?.control?.[action]();
  }
}
